module.exports = __webpack_public_path__ + "img/oops.4af9e668.png";